import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

export type MessageType =
  'notification' | 'error' | 'warning' | 'success' | 'info';

export type MessageSize = '' | 'small';

@Component({
  selector: 'lib-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessageComponent implements OnInit {
  @Input() type: MessageType = 'info';
  @Input() title = '';
  @Input() message = '';
  @Input() showCloseButton = false;
  @Input() size: MessageSize = '';

  @Output() closeButton = new EventEmitter<void>();

  closeLabel = '';

  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.closeLabel =
      this.translocoService.getActiveLang() === 'sv'
        ? 'Stäng meddelande'
        : 'Close message';
  }
}
